// DailyCo/DailyRoom.tsx
import React, {useEffect, useRef} from 'react';
import {useNavigate} from 'react-router-dom';
import DailyIframe, {DailyCall, DailyEventObject} from '@daily-co/daily-js';
import {useTheme} from "Theme/ThemeContext";
import {rgbToHex} from "@mui/system";

// Глобальный флаг для предотвращения дублирования
let hasCreatedFrame = false;

interface DailyRoomProps {
    roomName: string;
}

// TODO: Сделать чтобы кто попало не имел доступ к руме.
const DailyRoom: React.FC<DailyRoomProps> = ({roomName}) => {
    const containerRef = useRef<HTMLDivElement | null>(null);
    const callObjectRef = useRef<DailyCall | null>(null);
    const navigate = useNavigate();
    const {plt, theme, themeLoading} = useTheme();

    useEffect(() => {
        if (themeLoading) {
            console.log('Загрузка темы...');
            return;
        }

        console.log(`theme mode ${plt.mode}`);

        if (hasCreatedFrame) {
            console.warn('DailyFrame уже создан, пропускаем createFrame');
            return;
        }

        if (!containerRef.current) return;

        hasCreatedFrame = true;

        // Создаем iframe Daily
        const callObject = DailyIframe.createFrame(containerRef.current, {
            lang: 'ru',
            customLayout: true,
            showLeaveButton: true,
            showFullscreenButton: true,
            dailyConfig: {
                iceConfig: {
                    iceTransportPolicy: 'relay',
                },
            },
            cssText:
                ' .haircheck { background: #fff; }' +
                ' video { border-radius: 10px; }' +
                ' video.jsx-2016264320 { width: 100%; height: 100%; left: 0; top: 0; position: absolute; }' +
                ' .jsx-2309927547.info { border-radius: 0 5px 0 10px; } ' +
                ' .jsx-2122962381 { background: #F6F6F6; } ' +
                ' .speaker.jsx-2154060441 { padding: 0 20px; } ' +
                ' .volume { border-radius: 0 0 0 10px; overflow: hidden; } ' +
                ' .jsx-2309927547.mic.meter { position: relative; overflow: hidden; border-radius: 0 0 0 10px; } ' +
                ' .active.jsx-2154060441 { align-items: flex-start; }'
        });

        callObjectRef.current = callObject;

        callObject.setTheme({
            colors: {
                accent: rgbToHex(plt.colors.primary.main),
                accentText: '#fff', // Текст на кнопках ядовитых
                background: rgbToHex(plt.bg.primary),
                backgroundAccent: rgbToHex(plt.bg.primary),
                baseText: rgbToHex(plt.text.primary),
                border: rgbToHex(plt.bg.contrast15),
                mainAreaBg: rgbToHex(plt.bg.primary), // главный фон контейнера камеры внутри комнаты
                mainAreaBgAccent: rgbToHex(plt.bg.contrast05),
                mainAreaText: rgbToHex(plt.text.primary70),
                supportiveText: rgbToHex(plt.text.primary50),
            },
        });

        // Присоединяемся к комнате
        callObject.join({
            url: `https://life-help-ru.daily.co/${roomName}`,
            // Другие настройки при необходимости
        })
            .then(() => {
                console.log(`Успешно присоединились к комнате: ${roomName}`);
            })
            .catch((err) => {
                console.error('Ошибка при присоединении к комнате:', err);
            });

        // Слушаем событие 'left-meeting' для перенаправления на главную страницу
        const handleLeftMeeting = (event: DailyEventObject<'left-meeting'>) => {
            console.log('Пользователь покинул комнату');
            navigate(`/consultations?for_feedback=${roomName.split('_').pop()}`);
        };

        callObject.on('left-meeting', handleLeftMeeting);

        // Очистка при размонтировании компонента
        return () => {
            console.log('Разрушение DailyFrame при размонтировании компонента');
            callObject.off('left-meeting', handleLeftMeeting);
            callObject.leave();
            callObject.destroy();
            hasCreatedFrame = false;
        };
    }, [roomName, navigate, themeLoading, theme]);

    // Кастомная кнопка выхода из комнаты
    const handleCustomLeave = () => {
        if (callObjectRef.current) {
            callObjectRef.current.leave()
                .then(() => {
                    console.log('Покинули комнату');
                    navigate(`/consultations?for_feedback=${roomName.split('_').pop()}`);
                })
                .catch((err) => {
                    console.error('Ошибка при выходе из комнаты:', err);
                });
        }
    };

    return (
        !themeLoading && <div className="fc h-100" style={{display: 'flex', flexDirection: 'column', height: '100%'}}>
            <div
                ref={containerRef}
                style={{width: '100%', height: '100%', flexGrow: 1}}
            />
        </div>
    );
};

export default DailyRoom;
